<template>
    <v-container fluid fill-height>
      <v-layout align-center justify-center column v-if="error">
        <v-flex>
          <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <app-loading v-if="loading"></app-loading>
        <v-layout v-else justify-center>
          <v-flex xs12 sm8 md4>
            <!--            payment details-->
            <v-card class="mb-6">
              <!--              toolbar-->
              <v-toolbar color="primary" text dark>
                <v-toolbar-title class="black--text"><v-icon class="grey--text">payment</v-icon>Payment Settings</v-toolbar-title>
              </v-toolbar>
              <!--              Page details-->
              <v-expansion-panels accordion>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div v-if="enabledPaymentMethods != null" class="font-weight-bold subtitle-1">{{enabledPaymentMethods}}</div>
                    <div v-else class="font-weight-bold subtitle-1 red--text">No payment methods enabled</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content
                      v-for="paymentMethod in paymentMethods" :key="paymentMethod.id"
                  >
                    <v-card
                        class="mb-3">
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                          <v-card-title
                              class="text-h5"
                          >{{ paymentMethod.paymentMethod }}</v-card-title>

                          <v-card-subtitle>{{paymentMethod.title}}</v-card-subtitle>
                          <v-card-subtitle>
                            <div v-if="paymentMethod.enabled" class="green--text">Enabled</div>
                            <div v-if="!paymentMethod.enabled" class="red--text">Disabled</div>
                          </v-card-subtitle>
                          <v-card-actions>
                            <v-btn
                                class="ml-2 mt-5"
                                outlined
                                @click="configurePaymentDialog(paymentMethod.id)"
                            >
                              Configure
                            </v-btn>
                          </v-card-actions>
                        </div>

                        <v-avatar
                            class="ma-3"
                            size="125"
                            tile
                            @click="configurePaymentDialog(paymentMethod.id)"
                        >
                          <v-img :src="paymentMethod.thumbNailImg"></v-img>
                        </v-avatar>
                      </div>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
            <!--            transactions-->
            <v-card>
              <v-toolbar color="primary" dark>
                <v-toolbar-title class="black--text"><v-icon class="grey--text">receipt_long</v-icon>Transactions</v-toolbar-title>
              </v-toolbar>
              <!--users list-->
              <v-list two-line>
                <v-list-item
                    v-for="item in transactions"
                    :key="item.id"
                    @click="$router.push('/booking/' + item.orderId)"
                >
<!--                  <v-list-item-avatar>-->
<!--                    <v-icon>category</v-icon>-->
<!--                  </v-list-item-avatar>-->
                  <v-list-item-content class="text-xs-left">
                    <v-list-item-title>{{ item.transactionTitle }} - {{ item.amount }}</v-list-item-title>
                    <v-list-item-subtitle>{{item.paidBy.name}} - {{item.paidBy.phoneNumber}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{item.orderId}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <div v-if="item.direction === 'incoming'"><v-icon class="success--text">call_received</v-icon></div>
                    <div v-if="item.direction === 'outgoing'"><v-icon class="warning--text">call_made</v-icon></div>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
        <v-dialog v-model="paymentConfigureDialog"
                  ref="dialog"
                  persistent
                  width="580px"
        >
            <v-card v-if="selectedPaymentMethod">
                <v-card-title>
                    <div class="white black--text text-xs-center font-weight-thin headline">Configure {{selectedPaymentMethod.paymentMethod}}</div>
                </v-card-title>
                <v-card-text v-if="!loading">
                  <v-switch
                      v-model="selectedPaymentMethod.enabled"
                      color="blue"
                      label="Enabled"
                  ></v-switch>
                  <v-textarea
                      outlined
                      rows="3"
                      label="Details"
                      v-model="selectedPaymentMethod.description"
                  ></v-textarea>
                  <v-img
                      v-if="selectedPaymentMethod.imageUrl !== ''"
                      :src="selectedPaymentMethod.imageUrl"
                      width="450px"
                      @click="imageDialog = true"
                  ></v-img>
                  <v-img
                      v-if="selectedPaymentMethod.imageUrl === ''"
                      contain
                      src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FPayment%20Methods.png?alt=media&token=b85863d5-fdb7-42c5-be8b-dec9a5418594"
                      width="450px"
                      @click="imageUploadDialog = true"
                  ></v-img>
                </v-card-text>
                <app-loading v-else></app-loading>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="paymentConfigureDialog = false" text>cancel</v-btn>
                    <v-btn @click="updatePaymentMethods" dark class="blue">Update</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      <v-dialog v-model="imageDialog"
                width="300px"
                ref="dialog"
                persistent
      >
        <v-img
            v-if="selectedPaymentMethod"
            :src="selectedPaymentMethod.imageUrl"
            contain
            height="300px"
        >
        </v-img>
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined @click="deleteImage" class="red white--text">delete</v-btn>
            <v-btn @click="imageDialog = false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="imageUploadDialog"
                ref="dialog"
                persistent
                width="500px"
      >
        <v-card>
          <v-card-title>Select image to upload</v-card-title>
          <gen-img-uploader :path="path" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></gen-img-uploader>
          <v-card-text v-if="mediaUrl">
            <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :disabled="!mediaUrl" @click="uploadImgToPaymentMethod">ok</v-btn>
            <v-btn text @click="cancelImageUpload">cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>
import {collection, doc, onSnapshot, setDoc, getDocs} from "firebase/firestore";
import moment from "moment";
import {deleteObject, getStorage, ref} from "firebase/storage";
export default {
  data () {
    return {
      paymentConfigureDialog: false,
      transactions: [],
      listingDetails: undefined,
      imageUploadDialog: false,
      imageDialog: false,
      mediaUrl: undefined,
      imgId: null,
      path: 'pageViewContent',
      pickedImage: undefined,
      paymentMethods: [
        {
          id: 0,
          paymentMethod: 'Cash',
          title: 'C.O.D',
          enabled: false,
          description: '',
          thumbNailImg: 'https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2FCOD.png?alt=media&token=9b5d1ed7-448a-4149-bb4e-fed2924e86a2',
          imageUrl: ''
        },
        {
          id: 1,
          paymentMethod: 'E-transfer',
          title: 'Interac',
          enabled: false,
          description: '',
          thumbNailImg: 'https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2Fe-transfer.png?alt=media&token=afbbf29f-ecd7-41b5-8bf0-4ce32d23d6b7',
          imageUrl: ''
        },
        {
          id: 2,
          paymentMethod: 'Credit',
          title: 'Visa, Master Card, Amex, Discover',
          enabled: false,
          description: '',
          thumbNailImg: 'https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2Fcredit.png?alt=media&token=61bcd6f2-164c-482d-b8e9-e0dc0df65065',
          imageUrl: ''
        }
      ],
      selectedPaymentMethod: undefined,
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    moment () {
      return (date) => {
        let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
        return day
      }
    },
    error () {
      return this.$store.getters.error
    },
    user () {
      return this.$store.getters.user
    },
    enabledPaymentMethods () {
      let title = ""
      for (let i = 0; i < this.paymentMethods.length; i++) {
        if (this.paymentMethods[i].enabled) {
          title += ' '+ this.paymentMethods[i].paymentMethod
        }
      }
      if (title.length != 0) {
        return title
      } else {
        return null
      }
    }
  },
  created() {
    //console.log(this.user)
    this.$store.dispatch('setLoading', true)
    let db = this.$store.state.db
    // fetches transactions associated by this number
    let transactionsRef = collection(db, 'users', this.user.uid + '/transactions')
    onSnapshot(transactionsRef, res => {
          if (res && res.empty !== true) {
            let transactions = []
            let sortedTransactions = []
            res.forEach(doc => {
              let data = doc.data()
              // console.log(data)
              transactions.push(data)
            })
            sortedTransactions = transactions.sort((a, b) => {
              return b.created - a.created
            })
            this.transactions = sortedTransactions
          }
      this.$store.dispatch('setLoading', false)
    })
    let paymentsMethodsRef = getDocs(collection(db, 'users', this.user.uid + '/paymentMethods'))
        return paymentsMethodsRef
        .then((res) => {
          if (res && res.empty !== true) {
            let paymentMethods = []
            res.forEach(doc => {
              let data = doc.data()
              paymentMethods.push(data)
            })
            this.paymentMethods = paymentMethods.sort((a, b) => {
              return a.id - b.id
            })
          }
        })

  },
  methods: {
    configurePaymentDialog (id) {
      this.selectedPaymentMethod = this.paymentMethods[id]
      if (this.paymentMethods[id].imageId) {
        this.imgId = this.paymentMethods[id].imageId
      }
      this.paymentConfigureDialog = true
    },
    updatePaymentMethods () {
      let db = this.$store.state.db
      for (let i = 0; i < this.paymentMethods.length;) {
        let paymentMethod = this.paymentMethods[i].paymentMethod
        let paymentMethodsRef = doc(db, 'users', this.user.uid, '/paymentMethods/' + paymentMethod )
        setDoc(paymentMethodsRef, this.paymentMethods[i])
        i++;
      }
      this.paymentConfigureDialog = false
    },
    uploadImgToPaymentMethod () {
      let paymentId = this.selectedPaymentMethod.id
      this.paymentMethods[paymentId].imageUrl = this.mediaUrl
      this.paymentMethods[paymentId].imageId = this.imgId
      this.updatePaymentMethods ()
      this.imageUploadDialog = false
    },
    deleteImage () {
      this.imageDialog = false
      let paymentId = this.selectedPaymentMethod.id
      this.paymentMethods[paymentId].imageUrl = ''
      this.paymentMethods[paymentId].imageId = ''
      this.updatePaymentMethods ()
      this.imageUploadDialog = false
      let userId = this.user.uid
      let storage = getStorage()
      let imgRef = ref(storage, '/users/' + userId + '/'+ this.path +'/' + this.imgId)
      deleteObject(imgRef)
          .then (() => {
            this.imgId = null
          })
          .catch((err) => {
        this.$store.dispatch('setError', err)
      });
    },
    addImageLink (value) {
      this.mediaUrl = value.url
      this.imgId = value.id
    },
    removeImageLink () {
      this.mediaUrl = undefined,
          this.imgId = ''
    },
    cancelImageUpload () {
      this.imageUploadDialog = false
      this.mediaUrl = undefined
      this.deleteUploadedImage()
    },
    deleteUploadedImage () {
      if (this.imgId != null) {
        let userId = this.user.uid
        let storage = getStorage()
        let imgRef = ref(storage, '/users/' + userId + '/' + this.path + '/' + this.imgId)
        deleteObject(imgRef)
            .then (() => {
              this.imgId = null
            })
            .catch((err) => {
              this.$store.dispatch('setError', err)
            });
      }

    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>

